import { render } from "./ElNavigationClose.vue?vue&type=template&id=0b5f3a78&scoped=true&lang=html"
import script from "./ElNavigationClose.vue?vue&type=script&lang=js"
export * from "./ElNavigationClose.vue?vue&type=script&lang=js"

import "./ElNavigationClose.vue?vue&type=style&index=0&id=0b5f3a78&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b5f3a78"]])

export default __exports__